/*
 * AdminClaimDisapproveModal Messages
 *
 * This contains all the text for the AdminClaimDisapproveModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  downloadCSVButton: {
    id: 'admin.claims.downloadCSVButton',
    defaultMessage: 'Retrieve Validators Payment CSV',
  },
  creditLow: {
    id: 'admin.claims.creditLow',
    defaultMessage: 'The claim credit limit is low, Please top up.',
  },
  forceApproveSuccess: {
    id: 'admin.claims.forceApproveSuccess',
    defaultMessage: 'You have successfully approved the claim.',
  },
});



// WEBPACK FOOTER //
// ./src/ui/admin/claims/messages.js